/**
 * MAP.THUNK.TS
 * Custom endpoints
 */
import { createAsyncThunk } from "@reduxjs/toolkit"
import { fetchBackend } from "@/core/apis/backend"
import { Map } from "./map.types"

//Change order
export const order = createAsyncThunk("maps/order", async (maps: Map[]) => {
  await fetchBackend({
    url: `/maps/order`,
    method: "POST",
    data: { maps }
  })
  return maps
})
